import { useEffect, useState } from 'react';
import { IUser } from '../../@types/myAudit';
import { getUsers } from '../../../requests/users';
import {
  renderUserOptions,
} from '../sharedComponents/SearchBox/utils';
import { ISelectedOption } from '../../@types/searchBox';
import { useDebounce } from './useDebounce';
import { Nullable } from '../../@types/genericTypes';

export function useSearchUser (
  initialState: ISelectedOption[] = [],
  alreadyAssignedUsers?: Nullable<number>[]
) {
  const [searchText, setSearchText] = useState<string>('');
  const debounceSearchText = useDebounce(searchText);
  const [searchBoxOptions, setSearchBoxOptions] =
    useState<ISelectedOption[]>(initialState);
  const [selectedOptions, setSelectedOptions] =
    useState<ISelectedOption[]>(initialState);

  useEffect(() => {
    const userList: IUser[] = [];
    if (searchText.length > 0) {
      getUsers(debounceSearchText).then((response) => {
        response.results.map((user) => {
          if (
            alreadyAssignedUsers &&
            alreadyAssignedUsers.length > 0 &&
            alreadyAssignedUsers.includes(user.id)
          ) {
            return;
          }
          userList.push(user);
        });
        setSearchBoxOptions(renderUserOptions(userList));
      });
    }
  }, [debounceSearchText]);

  return {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSearchBoxOptions,
    setSelectedOptions,
    setSearchText,
  };
}
